<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><span aria-label="page vi" epub:type="pagebreak" id="page_vi" role="doc-pagebreak"><span aria-label="page vii" epub:type="pagebreak" id="page_vii" role="doc-pagebreak">HISTORIAN’S NOTE</span></span></h1>
<p class="noindent">The principal events of this story take place shortly after stardate 2258.42, in a parallel reality in which the <i>Starship Kelvin</i> was destroyed in 2233 by a Romulan invader (<i>Star Trek,</i> 2009<i>)</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// note.vue?ac44e8f0